// components/PatientTable.jsx
import {
    Box,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import React from 'react';

const PatientTable = ({ patientData, loading }) => {
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        borderRadius: 3, 
        overflow: 'hidden',
        height: '100%'
      }}
    >
      <Box 
        sx={{ 
          p: 2, 
          background: 'black', 
          color: 'white',
          borderBottom: '1px solid rgba(224, 224, 224, 0.4)'
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          Recent Patients
        </Typography>
      </Box>
      
      <TableContainer sx={{ maxHeight: 350 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                ID
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Name
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Phone
              </TableCell>
              <TableCell 
                sx={{ 
                  fontWeight: 700, 
                  backgroundColor: '#f5f5f5',
                  borderBottom: '2px solid #129bab'
                }}
              >
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                    <CircularProgress size={30} sx={{ color: '#129bab' }} />
                  </Box>
                </TableCell>
              </TableRow>
            ) : patientData && patientData.length > 0 ? (
              patientData.map((patient) => (
                <TableRow 
                  key={patient.id}
                  hover
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>{patient.ids}</TableCell>
                  <TableCell>{patient.name}</TableCell>
                  <TableCell>{patient.phone}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        backgroundColor:
                          patient.status === 'Active' ? '#4caf50' : '#f44336',
                        borderRadius: 1,
                        px: 1,
                        py: 0.5,
                        display: 'inline-block',
                        color: 'white',
                        fontSize: '0.8rem',
                        fontWeight: 600
                      }}
                    >
                      {patient.status}
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography variant="body1" py={2}>
                    No patients registered
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default PatientTable;